<template>
    <div class="Voting">
      <div class="titlePage" v-if="this.dataVoting.Det_VotingReference">{{this.dataVoting.Det_VotingReference}}</div>
      <div class="titlePage" v-else>Manual de Marca Ibero</div>
      <VotingForm v-if="renderComponent1" :InfoRange="this.dataVoting" :method="callVotar"/>
      <VotingResult v-if="renderComponent2" :InfoRange="this.dataVoting" />
      <div v-if="novoto" class="VotingResult">
        <va-notification color="warning" class="refNoData"></va-notification>
      </div>
    </div>
</template>

<script>
import VotingForm from '@/components/Voting/VotingForm.vue'
import VotingResult from '@/components/Voting/VotingResult.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'Voting',
  data () {
    return {
      renderComponent1: false,
      renderComponent2: false,
      novoto: false,
      dataVoting: [],
    }
  },
  components: {
    VotingForm,
    VotingResult,
  },
  methods: {
    callLoadData () {
      debugger

      window.location.href = 'https://app.box.com/embed/s/e0a3rhaa4wwtmo2efezlze89so8is3ab'
      // object
      // router.push({ path: 'https://app.box.com/embed/s/e0a3rhaa4wwtmo2efezlze89so8is3ab' })

      this.renderComponent1 = false
      this.renderComponent2 = false
      var totalinf = IberoHelpers.listVotingUser(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson)
      totalinf.then(Response => {
        if (!Response.data) {
          this.callListVoto()
        } else {
          if (Response.data.VotingUser.length >= 1) {
            this.dataVoting = Response.data
            IberoHelpers.forceRerender2(this)
          } else {
            this.callListVoto()
          }
        }
      })
    },
    callListVoto () {
      var totalinf = IberoHelpers.listVotingRange(this.$store)
      totalinf.then(Response => {
        if (Response.data) {
          this.dataVoting = Response.data.VotingRange[0]
          IberoHelpers.forceRerender1(this)
        } else {
          this.novoto = true
        }
      })
    },
    callVotar (valvoto) {
      debugger
      // object
      router.push({ path: 'https://app.box.com/embed/s/e0a3rhaa4wwtmo2efezlze89so8is3ab' })

      let loader = this.$loading.show()
      var totalinf = IberoHelpers.addVotoUser(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson, valvoto)
      totalinf.then(Response => {
        this.callLoadData()
        loader.hide()
      })
    },
  },
  created: function () {
    this.callLoadData()
  },
}
</script>

<style scoped>
.VotingResult{
    margin: 30px;
    padding: 20px;
}
.refNoData {
  padding: 10px;
  padding-left: 20px;
}
</style>
